export default interface IRoleItem {
    label: string,
    value: string
    extra: {
        entityType: number,
        positionId: number
    }
}